import { render, staticRenderFns } from "./CreatePhaseStatusFormStep2.vue?vue&type=template&id=0b7ed57e&scoped=true&"
import script from "./CreatePhaseStatusFormStep2.vue?vue&type=script&lang=ts&"
export * from "./CreatePhaseStatusFormStep2.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePhaseStatusFormStep2.vue?vue&type=style&index=0&id=0b7ed57e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ed57e",
  null
  
)

export default component.exports